// Naviagtion.js

var $ = require('jquery');
var isSticky = false;


$(document).ready(function() {
  
  // Menu Toggle
  $('.site-header .js-toggle').on('click', function(){
    $('.site-header').toggleClass('-active');
    $('body').toggleClass("-has-nav");
  });

  stickyMenu();
  accordionMobileMenu();
  toggleSearchForm();

})

// Menu Toggle
$(window).on('resize', function() {
  if(window.innerWidth >= 991) {
    toggleSearchForm();
    $(".site-header").removeClass("-active");
    $('body').removeClass("-has-nav");
  }
})

// Sticky Menu
$(window).on('resize scroll', function() {
  stickyMenu();
})



// Functions - - - - - - - - - - - - - - - - - - -
// - - - - - - - - - - - - - - - - - - - - - - - -


// - - - Sticky Primary Menu - - -
function stickyMenu() {
  var primaryMenu = $(".js-site-header__primary");
  var utilityMenu = $(".js-site-header__utility");
  var utilityMenuHeight = utilityMenu.outerHeight();
  
  if (window.innerWidth >= 991) {
    if(primaryMenu.length != 0) {
      if(!isInViewport(primaryMenu, -utilityMenuHeight)) {
        if(!isSticky){
          // Top of the PrimaryMenu
          primaryMenu.addClass("-sticky");
          isSticky = true;
        }
      } 
      if(isInViewport(utilityMenu, 0)) {
        if(isSticky){
          // Bottom of the UtilityMenu
          primaryMenu.removeClass("-sticky");
          isSticky = false;
        }
      }
    }
  } 
  else {
    primaryMenu.addClass("-sticky");
    isSticky = true;
  }
}


// - - - Accordion Mobile Menu - - -
function accordionMobileMenu() {
  var footerItem = '.js-site-footer__nav .menu > li';
  var allFooterSubMenu = $('.js-site-footer__nav .sub-menu');

  // Mobile Footer
  $(footerItem).on('click', function(){
    var currentSubMenu = $(this).find('.sub-menu');

    if(window.innerWidth <= 991) {
      allFooterSubMenu.slideUp();
    
      if($(this).hasClass('-extended')) {
        $(this).removeClass('-extended');
      } else {
        $(footerItem).removeClass('-extended');
        currentSubMenu.slideToggle();
        $(this).addClass('-extended');
      }
    }
  });

  // Adjust Footer
  $(window).on('resize', function() {
    if(window.innerWidth >= 991) {
      $(footerItem).each(function(){
        $(this).removeClass('-extended');
        allFooterSubMenu.css('display', 'flex');
      });
    }
    else {
      allFooterSubMenu.css('display', 'none');
    }
  }).trigger('resize');
}


// - - - Toggle Search Form - - -
function toggleSearchForm() {
  if(window.innerWidth >= 991) {
    $('.search__form .form__toggle').off().on('click', function(event) {
      event.preventDefault();
      $(this).parent().toggleClass('-show');
      $(this).parent().find('.search-field').trigger("focus");
    });
  }
}



// - - - Check if element is in viewport - - -
function isInViewport(elem, shift) {
  var elementTop = elem.offset().top + shift;
  var elementBottom = elementTop + elem.outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};